import estilos from "./HeroSecao.module.css";
import heroFundo from "../../assets/hero-fundo.jpg";

const HeroSecao = () => {
  return (
    <section className={estilos.hero}>
      <div className={estilos.fundoImagem}>
        <img src={heroFundo} alt="" aria-hidden="true" />
        <div className={estilos.gradienteSobreposicao} />
      </div>

      <div className={estilos.conteudo}>
        <span className={estilos.etiqueta}>// Desenvolvedor Backend</span>

        <h1 className={estilos.nome}>
          Walter{" "}
          <span className={estilos.nomeDestaque}>Fonseca Neto</span>
        </h1>

        <p className={estilos.titulo}>
          Desenvolvedor Fullstack com foco em Backend e Arquitetura de Software
        </p>

        <p className={estilos.descricao}>
          Construindo APIs robustas, sistemas estruturados e soluções escaláveis
          com C#, .NET e arquitetura limpa.
        </p>

        <div className={estilos.botoes}>
          <a href="#projetos" className={estilos.botaoPrimario}>
            Ver Projetos
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </a>
          <a href="#contato" className={estilos.botaoSecundario}>
            Contato
          </a>
        </div>
      </div>

      





    </section>);

};

export default HeroSecao;